import { supabase } from 'Services/supabaseClient'

export function updateMessageAttachment(payload, attachmentId) {
  return supabase.from('message_attachments').update(payload).eq('id', attachmentId)
}

export function updateMessage(editedAt, messageId) {
  return supabase.from('messages').update({ edited_at: editedAt }).eq('id', messageId)
}

export function editMessage(messageId, payload) {
  return supabase.from('messages').update(payload).eq('id', messageId)
}

export function fetchOlderMessages(userId) {
  return supabase.from('users').select('userid, first_name, last_name, users_flag_url, allow_personal_chat').eq('userid', userId).single()
}

export function getUserAllowPersonalChat(userId) {
  return supabase.from('users').select('userid, allow_personal_chat ').eq('userid', userId).single()
}

export function getMessageHasAttachmentsById(messageId) {
  return supabase.from('messages').select('has_attachments').eq('id', messageId).single()
}

export function getMessageAttachmentMediaTypesByMessageId(messageReplyId) {
  return supabase.from('message_attachments').select('media_type').eq('message_id', messageReplyId)
}

export function getUserForCommunityRealtimeMessage(userId) {
  return supabase.from('users').select('userid, first_name, last_name, users_flag_url, allow_personal_chat').eq('userid', userId).single()
}

export function getMessageReplyWithUser(messageReplyId) {
  return supabase.from('messages').select('id, userid, content, has_attachments, timestamp, user:users!messages_userid_fkey(userid, first_name, last_name, users_flag_url, allow_personal_chat)').eq('id', messageReplyId).single()
}

export function getCommunityMemberBlocked(communityId, userId) {
  return supabase.from('community_members').select('blocked').eq('community_id', communityId).eq('userid', userId).single()
}

export function getCommunityUserRole(activeCommunityId, userId) {
  return supabase.from('community_members').select('role').eq('community_id', activeCommunityId).eq('userid', userId).single()
}

export function getCanActAsBot(userId) {
  return supabase.from('users').select('can_act_as_bot').eq('userid', userId).single()
}

export function getCommunityMembersUnreadCounts(userId) {
  return supabase.from('community_members').select('community_id, unread_count, role').eq('userid', userId)
}

export function getKvAppSetting() {
  return supabase.from('kv_app_settings').select('create_community_count, community_instructions').limit(1).maybeSingle()
}

export function fetchUserDetailsFromSupabase(userId) {
  return supabase.from('users').select('userid, is_internal_user , can_act_as_bot').eq('userid', userId).single()
}

export function fetchSenderInfo(event) {
  return supabase.from('users').select('first_name, last_name, users_flag_url').eq('userid', event?.new?.userid).single()
}
